<template class="visor">
    <canvas v-once id="renderCanvas" touch-action="none"></canvas>
</template>

<script>
    import * as BABYLON from 'babylonjs';
    import buttonTex from "../assets/exit.png";
    import buttonVideoTex from "../assets/video.png";
    import data from "../assets/data.json";
    import Analytics from 'analytics';
    import googleAnalytics from '@analytics/google-analytics';

    let videos = [];
    let actualVideo;
    let photoDome;
    let x = 0;
    let y = 0;
    let z = 0;
    let myData;
    let camera;
    let tmpMeshTest;
    let menuMeshes = [];
    let myConnection;

    let typeButton = {
        MENU: 'menu',
        PLAY: 'play',
        EXIT: 'exit',
    };

    const analytics = Analytics({
        app: 'XLV Semana de Química Internacional',
        version: 100,
        plugins: [
            googleAnalytics({
                trackingId: 'UA-146619017-1 V',
            })
        ]
    });

    export default {
        name: 'Visor360',
        mounted() {
            let canvas = document.getElementById('renderCanvas');
            let engine = new BABYLON.Engine(canvas, true);
            analytics.page();

            let createScene = function(){
                let scene = new BABYLON.Scene(engine);
                scene.autoClear = false;
                scene.autoClearDepthAndStencil = false;
                scene.blockMaterialDirtyMechanism = true;
                scene.getAnimationRatio();
                myData = JSON.parse(JSON.stringify(data));

                camera = new BABYLON.DeviceOrientationCamera("camera", new BABYLON.Vector3(0, 0, 5), scene);
                camera.setTarget(BABYLON.Vector3.Zero());
                camera.attachControl(canvas, true);


                let light = new BABYLON.HemisphericLight('light1', BABYLON.Vector3.Zero(), scene);
                light.direction = new BABYLON.Vector3(0, 1, 0);

                NewRoom(data, scene, 0, true);

                Keys(false, scene, camera);

                document.addEventListener("visibilitychange", function() {
                    if(actualVideo){
                        actualVideo.Stop();
                    }
                }, false);

                return scene;
            };

            let scene = createScene();

            engine.runRenderLoop(function () {
                scene.render();
            });

            window.addEventListener('resize', function () {
                engine.resize();
            })
        },
    };

    const NewRoom = (data, scene, sceneID, isInit) => {

        for(let i = 0; i < menuMeshes.length; i++){
            menuMeshes[i].dispose();
        }

        if(videos.length > 0){
            for(let i = 0; i < videos.length; i++ ){
                videos[i].Destroy();
            }
            videos = [];
        }

        if(myConnection)
            myConnection.Destroy();

        let id = 0;

        if(isInit === true){
            photoDome = new BABYLON.PhotoDome(
                "room",
                require('../assets/init.png'),
                {resolution: 256},
                scene
            );

            photoDome.freezeWorldMatrix();
        }

        let dome = require("../assets/" + myData.scenes[sceneID].textureDome + ".png");
        photoDome.photoTexture = new BABYLON.Texture(dome, scene, false, false);
        photoDome.rotation = new BABYLON.Vector3(0 , 3.141592653589793, 0);
        photoDome.mesh.rotation = myData.scenes[sceneID].fixedRotation;

        //Se crea los videos y sus puntos respectivos
        if(sceneID === 0){
            Menu(scene);
        }else{
            myData.scenes[sceneID].points.forEach( point => {
                let myPoint = VideoFactory(id++, point, scene);
                myPoint.create();
                videos.push(myPoint);
            });

            id = 0;

            myData.scenes[sceneID].connections.forEach( connection => {
                myConnection = ExitFactory(id++, connection, scene);
                myConnection.Create();
            });
        }

    };

    const ExitFactory = (id, state, scene) => {
        let data = {
            id: id,
            room: state.room,
            name: "exit",
            go: state.go,
            position: state.position,
            rotation: state.rotation,
            mesh: null,
        };

        return({
            Create(){
                let matButton = new BABYLON.StandardMaterial("unlitButton", scene);
                matButton.diffuseTexture = new BABYLON.Texture(buttonTex, scene);
                matButton.diffuseTexture.hasAlpha = true;
                matButton.disableLighting = true;
                matButton.emissiveColor = new BABYLON.Color3(1, 1 , 1);
                matButton.freeze();
                data.mesh = BABYLON.Mesh.CreateGround(data.go + "-" + data.name, 40, 40,2, scene, false);
                data.mesh.material = matButton;
                data.mesh.position = data.position;
                data.mesh.rotation =  data.rotation;
                data.mesh.freezeWorldMatrix();
                AddEventListenerOnClick(data.mesh, scene, typeButton.EXIT);
            },

            Destroy() {
                data.mesh.dispose();
            },

            GetConnectionID(){
                return data.go;
            }
        })
    };

    const Menu = (scene) => {
        let isFirstElement = true;
        camera.position = new BABYLON.Vector3(0, 5, -10);

        let buttonMesh = BABYLON.Mesh.CreateGround("Button", 298/1.1, 209/1.1, 2, scene, false);

        myData.scenes[0].points.forEach(button => {
            if(isFirstElement){
                isFirstElement = false;
                let XLV = require("../assets/menu/XLV.png");
                let matXLV = new BABYLON.StandardMaterial('unlit', scene);
                matXLV.disableLighting = true;
                matXLV.emissiveColor = new BABYLON.Color3(1, 1 , 1);
                matXLV.freeze();


                matXLV.diffuseTexture = new BABYLON.Texture(XLV, scene, true);
                matXLV.diffuseTexture.hasAlpha = true;
                let buttonMesh = BABYLON.Mesh.CreateGround("Title", 2516/6, 676/6, 2, scene, false);
                buttonMesh.position = button.position;
                buttonMesh.rotation = button.rotation;
                buttonMesh.material = matXLV;
                buttonMesh.freezeWorldMatrix();
                buttonMesh.doNotSyncBoundingInfo = true;
                buttonMesh.cullingStrategy = BABYLON.AbstractMesh.CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY;


                menuMeshes.push(buttonMesh);
            }
            else {
                let matPoint = new BABYLON.StandardMaterial('unlit', scene);
                let texture = require("../assets/menu/"+ button.name + ".png");
                matPoint.disableLighting = true;
                matPoint.emissiveColor = new BABYLON.Color3(1, 1 , 1);
                matPoint.diffuseTexture = new BABYLON.Texture(texture, scene, true);
                matPoint.diffuseTexture.hasAlpha = true;
                matPoint.freeze();

                let cloneMenuButton = buttonMesh.clone(button.id);

                cloneMenuButton.position = button.position;
                cloneMenuButton.rotation = button.rotation;
                cloneMenuButton.material = matPoint;
                cloneMenuButton.freezeWorldMatrix();
                cloneMenuButton.doNotSyncBoundingInfo = true;
                cloneMenuButton.convertToUnIndexedMesh();
                cloneMenuButton.cullingStrategy = BABYLON.AbstractMesh.CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY;
                menuMeshes.push(cloneMenuButton);
                AddEventListenerOnClick(cloneMenuButton, scene, typeButton.MENU);
            }
        });

        buttonMesh.dispose();
    };

    let AddEventListenerOnClick = (mesh, scene, type) => {
        switch (type) {
            case typeButton.MENU:
                mesh.actionManager = new BABYLON.ActionManager(scene);
                mesh.actionManager.registerAction(
                    new BABYLON.ExecuteCodeAction(
                        BABYLON.ActionManager.OnPickTrigger,
                        function () {
                            let id = mesh.name;
                            NewRoom(data, scene, id, false);
                        }
                    )
                );
                break;
            case typeButton.PLAY:
                    mesh.actionManager = new BABYLON.ActionManager(scene);
                    mesh.actionManager.registerAction(
                        new BABYLON.ExecuteCodeAction(
                            BABYLON.ActionManager.OnPickTrigger,
                            function(){
                                if(actualVideo){
                                    actualVideo.Stop();
                                    actualVideo = null;
                                }
                                let id = mesh.name;
                                let name = videos[id].GetName();
                                analytics.track(name);

                                //videos[id].CreateVideo();
                                videos[id].Play();
                                actualVideo = videos[id];
                            }
                        )
                    );
                    break;
            case typeButton.EXIT:
                    mesh.actionManager = new BABYLON.ActionManager(scene);
                    mesh.actionManager.registerAction(
                        new BABYLON.ExecuteCodeAction(
                            BABYLON.ActionManager.OnPickTrigger,
                            function () {
                                for(let i = 0; i < videos.length; i++){
                                    videos[i].Stop();
                                }
                                actualVideo = null;
                                NewRoom(data, scene, 0, false);
                            }
                        )
                    );
                    break;
        }
    };

    const VideoFactory = (id, state, scene) => {
        let data = {
            id: id,
            name: state.name,
            title: state.title,
            nTitle: state.nTitle,
            position: state.position,
            rotation: state.rotation,
            videoSrc: state.videoSrc,
            raw: null,
            scene: scene,
            videoMesh: null,
            pointMesh: null,
            titleMesh: null,
            video: null,
            texVideo: null,
            meshClone: null
        };

        return({

            GetName(){
                return data.name;
            },

            create(){
                //Point Mesh
                let matPoint = new BABYLON.StandardMaterial('unlit', data.scene);
                data.raw = require("../assets/" + data.videoSrc + ".mp4");
                matPoint.disableLighting = true;
                matPoint.emissiveColor = new BABYLON.Color3(1, 1 , 1);
                matPoint.diffuseTexture = new BABYLON.Texture(buttonVideoTex, scene, true);
                matPoint.diffuseTexture.hasAlpha = true;
                data.pointMesh = BABYLON.Mesh.CreateGround(data.id, 80, 80, 2, data.scene, false);
                data.pointMesh.position = data.position;
                data.pointMesh.rotation = data.rotation;
                data.pointMesh.material = matPoint;
                data.pointMesh.freezeWorldMatrix();
                data.name = data.videoSrc;
                AddEventListenerOnClick(data.pointMesh, scene, typeButton.PLAY);

                let matVideo = new BABYLON.StandardMaterial('video', data.scene);
                matVideo.disableLighting = true;
                matVideo.emissiveColor = new BABYLON.Color3(1,1, 1);
                data.texVideo = new BABYLON.VideoTexture("video", data.raw, data.scene);
                data.texVideo.video.setAttribute('autoplay', 'true');
                matVideo.diffuseTexture = data.texVideo;
                matVideo.freeze();
                data.video = data.texVideo.video;
                data.video.pause();


                data.videoMesh = BABYLON.Mesh.CreateGround(data.id + "-" + data.name, 160*4, 90*4, 2, data.scene, false);
                data.videoMesh.material = matVideo;
                data.videoMesh.position = data.position;
                data.videoMesh.rotation = data.rotation;
                data.videoMesh.setEnabled(false);
                data.videoMesh.freezeWorldMatrix();
            },

            CreateVideo(){
                //Video Mesh
                let matVideo = new BABYLON.StandardMaterial('video', data.scene);
                matVideo.disableLighting = true;
                matVideo.emissiveColor = new BABYLON.Color3(1,1, 1);
                data.texVideo = new BABYLON.VideoTexture("video", data.raw, data.scene);
                data.texVideo.video.setAttribute('autoplay', 'true');
                matVideo.diffuseTexture = data.texVideo;
                data.video = data.texVideo.video;

                data.videoMesh = BABYLON.Mesh.CreateGround(data.id + "-" + data.name, 160*4, 90*4, 2, data.scene, false);
                data.videoMesh.material = matVideo;
                data.videoMesh.position = data.position;
                data.videoMesh.rotation = data.rotation;
            },

            Destroy() {
                data.pointMesh.dispose();
            },

            Play(){
                data.videoMesh.setEnabled(true);
                data.pointMesh.setEnabled(false);
                data.videoMesh.setEnabled(true);
                data.video.play();
            },

            Stop(){
                data.pointMesh.setEnabled(true);
                if(data.videoMesh){
                    data.videoMesh.dispose();
                }
                if(data.video){
                    data.video.pause();
                }

            },

            GetMeshPoint(){
                return data.pointMesh;
            }

        })
    };


    const Keys = (isActivate , scene, camera) => {
        if(isActivate){
            let map = {};
            scene.actionManager = new BABYLON.ActionManager(scene);

            scene.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnKeyDownTrigger, function (evt) {
                map[evt.sourceEvent.key] = evt.sourceEvent.type == "keydown";

            }));

            scene.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnKeyUpTrigger, function (evt) {
                map[evt.sourceEvent.key] = evt.sourceEvent.type == "keydown";
            }));

            //Keys

            scene.registerAfterRender(function() {
                if((map["w"])){
                    tmpMeshTest.rotation = new BABYLON.Vector3(x, y, z);
                    x += 0.01;
                }
            });
            scene.registerAfterRender(function() {
                if((map["s"])){
                    tmpMeshTest.rotation = new BABYLON.Vector3(x, y, z);
                    x -= 0.01;
                }
            });


            scene.registerAfterRender(function() {
                if((map["a"])){
                    tmpMeshTest.rotation = new BABYLON.Vector3(x, y, z);
                    y -= 0.01;
                }
            });

            scene.registerAfterRender(function() {
                if((map["d"])){
                    tmpMeshTest.rotation = new BABYLON.Vector3(x, y, z);
                    y += 0.01;
                }
            });

            scene.registerAfterRender(function() {
                if((map["q"])){
                    tmpMeshTest.rotation = new BABYLON.Vector3(x, y, z);
                    z += 0.01;
                }
            });

            scene.registerAfterRender(function() {
                if((map["e"])){
                    tmpMeshTest.rotation = new BABYLON.Vector3(x, y, z);
                    z -= 0.01;
                }
            });


            //Move
            scene.registerAfterRender(function() {
                if((map["f"])){
                    tmpMeshTest = videos[4].GetMeshPoint();
                    tmpMeshTest.position = camera.getFrontPosition(800);
                    console.log(tmpMeshTest.name);
                }
            });



            scene.registerAfterRender(function() {
                if((map["p"])){
                    console.log(tmpMeshTest.position);
                    console.log(tmpMeshTest.rotation);
                }
            });
        }
    };

</script>

<style scoped>
    #renderCanvas {
        width: 100%;
        height: 100%;
        touch-action: none;
    }
</style>
